"use client";

import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect } from "react";
import { env } from "@/env.mjs";

declare global {
  // biome-ignore lint/nursery/useConsistentTypeDefinitions: interface needed for declaration merging
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const GA_ID = env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const META_PIXEL_ID = env.NEXT_PUBLIC_META_PIXEL_ID;

export function AnalyticsScriptsProvider() {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", { page_path: url });
      }
      if (typeof window.fbq === "function") {
        window.fbq("track", "PageView");
      }
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => router.events.off("routeChangeComplete", handleRouteChange);
  }, [router.events]);

  return (
    <>
      {GA_ID && (
        <Script
          id="ga-script"
          onLoad={() => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = (...args: unknown[]) => {
              window.dataLayer!.push(args);
            };
            // oxlint-disable-next-line react-doctor/rendering-hydration-mismatch-time -- runs in a client-only Script onLoad callback, never during SSR
            window.gtag("js", new Date());
            window.gtag("config", GA_ID);
          }}
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
          strategy="afterInteractive"
        />
      )}
      {META_PIXEL_ID && (
        <Script id="meta-pixel-init" strategy="afterInteractive">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${META_PIXEL_ID}');
            fbq('track', 'PageView');
          `}
        </Script>
      )}
    </>
  );
}
